export function convertToYMD(date){
    //console.log(date)
    if (!date) return "";
    const thaiYear = date.getFullYear(); // แปลงปี ค.ศ. เป็น พ.ศ.
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // เดือนเริ่มจาก 0 จึงต้อง +1
    return `${thaiYear}-${month}-${day}`;
};
